module.exports = __webpack_public_path__ + "fonts/OpenSans-Light.48fa38b8.woff";